import { Pagination, Stack, TablePagination } from "@mui/material";
import { ROWS_PER_PAGE_OPTIONS } from "./helpers/urlParams";

interface Props {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
}

/**
 * The app's standard table footer: a spacer TablePagination, a centred
 * Pagination for page numbers, and a second TablePagination exposing only the
 * rows-per-page select. The "X–Y of Z" label is hidden on all of them, as
 * everywhere else in the product.
 *
 * Every Fetcher Settings table uses the same footer, so it lives here rather
 * than being copied into each <Subject>Table.
 */
const FetcherTablePagination = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}: Props) => (
  <Stack
    spacing={1}
    direction="row"
    justifyContent="space-between"
    alignItems="center"
  >
    <TablePagination
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={(_, newPage) => onPageChange(newPage)}
      onRowsPerPageChange={(event) =>
        onRowsPerPageChange(Number(event.target.value))
      }
      classes={{ displayedRows: "hidden-displayed-rows" }}
      sx={{
        ".MuiTablePagination-actions": { display: "none" },
        ".MuiTablePagination-input": { marginLeft: "15px" },
        ".MuiTablePagination-toolbar": { paddingLeft: "16px" },
      }}
    />
    <Pagination
      count={Math.max(1, Math.ceil(count / rowsPerPage))}
      page={page + 1}
      showFirstButton
      showLastButton
      className="pagination-button"
      color="secondary"
      size="small"
      onChange={(_, value) => onPageChange(value - 1)}
    />
    <TablePagination
      rowsPerPageOptions={[]}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={(_, newPage) => onPageChange(newPage)}
      classes={{ displayedRows: "hidden-displayed-rows" }}
      sx={{
        ".MuiTablePagination-select,.MuiTablePagination-selectLabel": {
          display: "none",
        },
        ".MuiTablePagination-actions": { display: "none" },
        ".MuiTablePagination-toolbar": { paddingRight: "16px" },
      }}
    />
  </Stack>
);

export default FetcherTablePagination;
